import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

type ModalWarningMessageProps =
  | {
      open: boolean;
      onNo: () => void;
      onYes: () => void;
      message: string;
      hasAnnulla?: never;
      onCloseAnnulla?: never;
    }
  | {
      open: boolean;
      onNo: () => void;
      onYes: () => void;
      message: string;
      hasAnnulla: boolean;
      onCloseAnnulla: () => void;
    };

const ModalWarningMessage = ({
  open,
  onNo,
  onYes,
  message,
  hasAnnulla,
  onCloseAnnulla,
}: ModalWarningMessageProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <DialogContent style={{ padding: '30px 24px' }}>{message}</DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="primary" type="button" onClick={() => onYes()}>
          SI
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onNo()}>
          NO
        </PmiButton>
        {hasAnnulla ? (
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            type="button"
            onClick={() => (onCloseAnnulla ? onCloseAnnulla() : null)}
          >
            ANNULLA
          </PmiButton>
        ) : null}
      </DialogActions>
    </PmiDialog>
  );
};

ModalWarningMessage.displayName = 'Modal informative message';

export default ModalWarningMessage;
